"use client";

import {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

export interface OSInfo {
  os: string;
  version: string;
}

const OSContext = createContext<OSInfo>({ os: "Unknown", version: "Unknown" });

export const useOS = () => useContext(OSContext);

function getOSInfo() {
  const userAgent =
    window.navigator.userAgent ||
    window.navigator.vendor ||
    (window as any).opera;

  if (/android/i.test(userAgent)) {
    const match = userAgent.match(/Android\s([0-9.]*)/);
    return { os: "Android", version: match ? match[1] : "Unknown" };
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    const match = userAgent.match(/OS\s([0-9_]*)/)?.[1]?.replace(/_/g, ".");
    return { os: "iOS", version: match || "Unknown" };
  }

  return { os: "Unknown", version: "Unknown" };
}

export const OSProvider = ({ children }: { children: ReactNode }) => {
  const [osInfo, setOSInfo] = useState<OSInfo>({
    os: "Unknown",
    version: "Unknown",
  });

  useEffect(() => {
    const os = getOSInfo();
    setOSInfo(os);
  }, []);

  return <OSContext.Provider value={osInfo}>{children}</OSContext.Provider>;
};
